import { Component, OnInit, Input, ViewEncapsulation, OnChanges, AfterViewInit } from '@angular/core';
import { I18nPluralPipe } from '@angular/common';
import { IVariantGrouping } from "../../Interfaces/IVariantGrouping";
import { IVariantGroupingType } from "../../Interfaces/IVariantGroupingType";
import { Scene7Helper } from "../../helpers/scene7.helper";
import { ProductsService } from "../../Services/products.service";
import { ICategoryBrowseFilterOptions } from "../../Interfaces/ICategoryBrowseFilterOptions";

@Component({
    selector: 'kws-product-card',
    templateUrl: './product-card.component.html',
    encapsulation: ViewEncapsulation.None
})
export class ProductCardComponent implements OnInit, OnChanges, AfterViewInit {
    @Input() displayType: string;
    @Input() product: IVariantGrouping;
    @Input() variantGroupingTypes: IVariantGroupingType;
    finishes: any;
    starMarkup: string;
    calculatedRating: any;
    comingSoon: boolean;
    currentParams: ICategoryBrowseFilterOptions;

    constructor(public productsService: ProductsService) {
        this.currentParams = this.productsService.getFilterOptionParams();
    }

    ngOnInit() {
        this.getStarMarkup();
        this.getCalculatedRating();
        let avblDate = this.product.availableDate;
        let availableDate = new Date(avblDate); //dd-mm-YYYY
        let today = new Date();

        this.comingSoon = availableDate > today;
        //console.log(this.currentParams);
    }

    ngOnChanges() {
        const finishCount = this.product.finishes.length;
        this.finishes = `${finishCount} ${finishCount === 1 ? 'finish' : 'finishes'}`;

        for (let i = 0; i < this.product.finishes.length; i++) {
            let productFinish = this.product.finishes[i];

            if (productFinish.title == this.currentParams.finish) {
                this.product.primaryImage = productFinish.productImage;
                this.product.variantSlug = productFinish.variantSlug;
                if (productFinish.isDiscontinued == true)
                    this.product.isDiscontinued = true;
            }
        }
    }

    ngAfterViewInit() {
    }

    getProductImage(product) {
        if (product) {
            return Scene7Helper.imagePath(product, 'Kwikset', 'kwsProductLarge');
        } else {
            return Scene7Helper.imagePath('no-image', 'Kwikset', 'kwsProductLarge');
        }

    }

    getProductDetailUrl() {
        if (this.product.variantSlug && this.product.defaultFinish && this.product.selectedFinish !== this.product.defaultFinish.slug) {
            return `/products/detail/${this.product.slug}?variant=${this.product.variantSlug}`;
        } else {
            return `/products/detail/${this.product.slug}`;
        }
    }

    getStarMarkup() {
        let markup = '';
        for (let i = 0; i < 5; i++) {
            markup = markup.concat(`<span class="fa ${this.getNextStarClass(this.product.rating, i)}"></span>`);
        }
        this.starMarkup = markup;
    }

    getNextStarClass(productRating, i) {
        let nextClass: string = 'fa-';
        let val = productRating - i;

        if (val >= 1) {
            nextClass += 'star';
        } else if (val >= 0.5 && val <= 0.99) {
            nextClass += 'star-half-o';
        } else {
            nextClass += 'star-o'
        }

        return nextClass;
    }

    getCalculatedRating() {
        if (this.product.rating > 0) {
            this.calculatedRating = this.product.rating;
        } else {
            this.calculatedRating = ''
        }
    }

    itemPluralMapping = {
        'review': {
            '=0': '',
            '=1': '1 review',
            'other': '# reviews'
        }
    }

}



// WEBPACK FOOTER //
// ./src/ts/Apps/Common/components/product-card/product-card.component.ts